// src/theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    typography: {
        fontFamily: 'Montserrat, sans-serif',
    },
    palette: {
        primary: {
            main: '#31174b', // Color violeta de Mevuelo (ajusta el valor hexadecimal según necesites)
        },
        secondary: {
            main: '#ff6700', // Color naranja de Mevuelo (ajusta el valor hexadecimal según necesites)
        },
    },
});

export default theme;
